// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import { CLS_PREFIX } from '../../constants';
import IconButton from '../IconButton';
import Icon from '../Icon';

import './Header.less';

const Header = ({ baseClassName, onClose, children, backButton, ...props }) => (
    <div className={baseClassName} {...props}>
        {backButton && onClose && (
            <IconButton
                className={`${baseClassName}__icon ${baseClassName}__back-button`}
                icon={<Icon name="chevron-left" className={`${baseClassName}__icon`} />}
                onClick={onClose}
            />
        )}
        <h4 className={`${baseClassName}__title`}>{children}</h4>
        {onClose && !backButton && (
            <IconButton
                icon={<Icon name="cross-mark" className={`${baseClassName}__icon`} />}
                onClick={onClose}
            />
        )}
    </div>
);
Header.propTypes = {
    baseClassName: PropTypes.string,
    onClose: PropTypes.func,
    children: PropTypes.node.isRequired,
    backButton: PropTypes.bool,
};
Header.defaultProps = {
    onClose: null,
    baseClassName: `${CLS_PREFIX}drawer-header`,
    backButton: false,
};

export default Header;



// WEBPACK FOOTER //
// ./components/Drawer/Header.js